module.exports = __webpack_public_path__ + "img/capeverde.3c842e86.svg";